import { ROOM_BOOKING_PATH } from '../../../RoomBooking/constants';

export const GOOGLE_BEAM_LANDING_URL =
  'https://www.industriousoffice.com/lp/google-beam-industrious';

export const GOOGLE_BEAM_PROMO_STORAGE_KEY = 'google-beam-promo-dismissed';

interface GoogleBeamCity {
  city: string;
  location: string;
  locationId: string;
}

// Locations with a Google Beam room. Each city links to meeting room
// booking at that location.
export const GOOGLE_BEAM_CITIES: GoogleBeamCity[] = [
  {
    city: 'New York City',
    location: 'Tower 49',
    locationId: '663d02f31f265b59704bc307',
  },
  {
    city: 'Chicago',
    location: 'Ogilvie',
    locationId: '6424657d16a40d45431865cb',
  },
  {
    city: 'Atlanta',
    location: 'Ponce City Market',
    locationId: '6424657d16a40d45431865e9',
  },
  {
    city: 'San Francisco',
    location: 'Financial District',
    locationId: '6424657d16a40d4543186633',
  },
];

// The room booking page is served by the website app (routed by
// CloudFront), so this is a full-page link, not an in-app route.
export const getGoogleBeamBookingUrl = (locationId: string) =>
  `${ROOM_BOOKING_PATH}?locationId=${locationId}`;
